import React, {useContext, useEffect, useState} from 'react';
import TaskItemBox from "./DashboardItems/TaskItemBox";
import TrackingItemBox from "./DashboardItems/TrackingItemBox";
import DynaSelectBox from "../../../../Components/A13/DynaView/DynaSelectBox";
import {StartDateIcon} from "./DashboardTypeSVG/DashboardTypeSVG";
import ModalAmendmentsText from "./DashboardItems/ModalAmendmentsText";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import {SetPrintDataContext} from "../../../index";
import {useNavigate} from "react-router-dom";

const DashboardArkaProgrammer = ({data , setRefreshData , refreshData}) => {

  const setprint = useContext(SetPrintDataContext);
  const navigateTo = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({})
  const [printData, setPrintData] = useState({
    version: "",
    printType: "",
  })
  const [documentPrint, setDocumentPrint] = useState({});

  const printType = [
    {label: "فرم تحلیل گزارش", value: "reportAnalysisForm"},
    {label: "فرم تحلیل نیازها", value: "needsAnalysisForm"},
    {label: "فهرست زیر سیستم ها", value: "listOfSubsystems"},
    {label: "نمودار ER", value: "ErDiagram"},
    {label: "مشخصات رابطه ها", value: "characteristicsOfRelationships"},
    {label: "رابطه ها", value: "relationships"},
    {label: "دامنه ها", value: "domains"},
    {label: "فهرست ورژن ها", value: "listOfVersions"},
    {label: "نمایش فرم", value: "showForm"},
    {label: "فرم QA", value: "QAForm"},
    {label: "فهرست API", value: "listOfAPIs"},
    {label: "فهرست تحلیل ها", value: "analysisList"},
    {label: "فهرست فرم ها", value: "listOfForms"},
  ];

  useEffect(() => {
    if (data?.versions && data?.versions.length > 0) {
      setPrintData({...printData, version: data?.versions[0].value})
    }
  }, []);

  useEffect(() => {
    if (printData?.version !== "") {
      _axios.get(prefixUrl() + "/arkaPrints/?request=documentPrint&type=version&id=" + printData?.version).then((response) => {
        if (response.data.status) {
          setDocumentPrint(response?.data?.data)
        } else {
          setDocumentPrint({})
          setPrintData({...printData, printType: ""})
          toast.error(response?.data?.message);
        }
      })
    }
  }, [printData?.version]);

  const printDataHandler = () => {
    if (printData?.version === "") {
      return toast.error("ورژن را انتخاب کنید")
    }
    if (printData?.printType === "") {
      return toast.error("نوع پرینت را انتخاب کنید")
    }

    const data = {
      type: printData?.printType,
      data: documentPrint[printData.printType]
    }
    setprint(data)
    navigateTo("/factorprint")
  }

  try {
    return (
      <section className={"main-DashboardType11Arka DashboardArkaProgrammer"}>
        <div className={"sec-right"}>
          <TaskItemBox data={data} setRefreshData={setRefreshData} refreshData={refreshData}/>
          <TrackingItemBox data={data}/>
        </div>

        <div className={"sec-left"}>

          <div className={"sec-left-item"}>
            <h6>پرینت</h6>
            <div className={"sec-left-item-box"}>
              <DynaSelectBox options={data?.versions}
                             hasFilter={false}
                             label={"نام ورژن"}
                             className={"solid-dyna-input"}
                             value={printData?.version}
                             onChange={(data) => setPrintData({...printData, version: data?.value})}
              />
              <DynaSelectBox options={Object.keys(documentPrint).length > 0 ? printType : []}
                             hasFilter={false}
                             label={"نوع پرینت"}
                             className={"solid-dyna-input"}
                             value={printData?.printType}
                             onChange={(data) => setPrintData({...printData, printType: data?.value})}
              />
              <div className={"sec-left-but"}>
                <button onClick={printDataHandler}>پرینت</button>
              </div>
            </div>
          </div>

          {data?.amendments && data?.amendments.length > 0 &&
            <div className={"sec-left-item"}>
              <h6>اصلاحیه ها</h6>
              <div className={"sec-left-item-box amendments-side"}>
                {data?.amendments.map((item, index) =>
                  <div key={index + "am"} className={"amendments"}>
                    <h4>{item?.title}</h4>
                    <div className={"description"}>
                      <h5>{item?.description}</h5>
                      <button onClick={() => {
                        setShowModal(true)
                        setModalData(item)
                      }}>مشاهده
                      </button>
                    </div>
                    <span>
                      <StartDateIcon/>
                      <h5>{item?.date + "  " + item?.time}</h5>
                    </span>
                  </div>
                )}
              </div>
            </div>
          }
        </div>
        {showModal && <ModalAmendmentsText onClose={() => setShowModal(false)} data={modalData}/>}
      </section>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default DashboardArkaProgrammer;